const theme = {
    colors: {
      lightGreen: "#9CD7B6",
      semiLightGreen: "#9CD7B650",
      darkBlue: "#082434",
      semiDarkBlue: "#08243450",
      climateGreen: "#349564",
      waterBlue: "#2FBDEF",
      healthPink: "#FF8DA3",
      fairnessOrange: "#F86E47",
      bonus: "#FEDF55",
      bg: {
        white: "#fff",
        grey: "#e8eaea",
        twgray: "#c9d1d0",
        lightgrey: "#f5f5f6",
      },
      categories: {
        meatAndPoultry: "#F26C65",
        curedMeats: "#FF90A6",
        fish: "#6CA7C4",
        vegetarian: "#349864",
        sides: "#FEDF88",
        diary: "#6C6CC1",
        bread: "#D6B492",
        readyMade: "#FB6E47",
        pantry: "#FECA38",
        canned: "#C6C6C6",
        flavourings: "#998675",
        vegetables: "#18684B",
        fruits: "#C14D92",
        desserts: "#E86B87",
        snacks: "#AA7DCC",
        drinks: "#2170A5",
        health: "#EF473F",
        kids: "#7DC6B8",
        animals: "#FC9B3A",
        other: "#acacac",
      },
    },
    chart: {
      tooltip: {
        boxPadding: 3,
      },
    },
    breakpoints: {
      mobile: "576px",
      tablet: "768px",
      laptop: "992px",
      desktop: "1200px",
    },
  };
  
  export const hexToRgba = (hex, opacity) => {
    // Remove the hash if present
    hex = hex.replace(/^#/, "");
  
    // Parse the hex value to RGB
    const bigint = parseInt(hex, 16);
    const r = (bigint >> 16) & 255;
    const g = (bigint >> 8) & 255;
    const b = bigint & 255;
  
    // Calculate the RGBA values
    const alpha = opacity / 100;
  
    // Return the RGBA string
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
  };
  
  export default theme;
  